export enum Metric {
    MISSED_FRAMES = 'missed_frames',
    HITCHES_RATE = 'hitches_rate'
}

export enum GameXpMetric {
    PLAYERS = 'players',
    PERCENTILE = 'percentile',
    ACTIVATIONS = 'activations'
}
